import { render, staticRenderFns } from "./RolesModal.vue?vue&type=template&id=79e3358a&scoped=true"
import script from "./RolesModal.vue?vue&type=script&lang=js"
export * from "./RolesModal.vue?vue&type=script&lang=js"
import style0 from "./RolesModal.vue?vue&type=style&index=0&id=79e3358a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e3358a",
  null
  
)

export default component.exports